import { RightOutlined, SearchOutlined , EyeOutlined, PrinterOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import { Button, Col, DatePicker, Form, Input, PageHeader, Row, Select, Space, Spin, Table } from 'antd'
import moment from 'moment';

import JcpMonthlyPaidListView from '../../components/enrollment/jcp/JcpMonthlyPaidListView'
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'

import { SUCCESS_STATUS , DATE_FORMAT_DMY_SLASH, TAP_PROGRAM_ID } from '../../utility/Constants'
import memberService from "../../api/member.service";
import JcpMonthlyReminderListView from "../../components/enrollment/jcp/JcpMonthlyReminderListView";
import TapMembershipListView from "../../components/tapcomponent/TapMembershipListView";
import commonUtility from "../../utility/Utils";
import TapBookingListView from "../../components/tapcomponent/TapBookingListView";
import TapDailyBookingCardView from "../../components/tapcomponent/TapDailyBookingCardView";
import { DATE_FORMAT_DMY_HYPHEN } from "../../utility/Constants";
import { TAP_ADULT_COAHING_PRINT_URL, TAP_COACH_REPORT_URL, TAP_INVOICE_BOOKING_LIST_PDF_URL, TAP_SPECIAL_DAILY_PRINT_URL } from "../../utility/URL";
import * as XLSX from 'xlsx';
import axios from 'axios';
const { Option } = Select;



const currdate = new Date();
//const currMonth = currdate.toLocaleString('default', { month: 'short' });
const currMonth = currdate.getMonth() + 1;
const currYear = currdate.getFullYear();

const defaultFormValues = {
    from_date: commonUtility.firstDateOfMonth("-"),
    to_date :  commonUtility.lastDateOfMonth("-"),
    //tap_group : 'TAPM',
    is_active : 'ACTIVE'

};


const columns = [
    {
        title: 'Name',
        dataIndex: 'member_fname',
        key: 'member_fname',
    },
    {
        title: 'Mobile No',
        dataIndex: 'primary_mobile',
        key: 'primary_mobile',
    },
    {
        title: 'Father',
        dataIndex: 'father_name',
        key: 'father_name',
    },
];


const TapCoachReport = () => {

    const [form] = Form.useForm();

    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [reminderLoaderEnable, setReminderLoaderEnable] = useState(false);
    const [selectedFromDate, setSelectedFromDate] = useState(commonUtility.todayDate("-"));
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [jsonData, setJsonData] = useState(null);


    const [tapBookingPDFUrl, setTapBookingPDFUrl] = useState("");

   
    /*
      const exportToExcel = async () => {
        try {
          const response = await axios.get('https://jsonplaceholder.typicode.com/users');
          const responseData = response.data;
          setJsonData(responseData);
      
          const transformedData = responseData.map((item) => Object.values(item));
          const worksheet = XLSX.utils.aoa_to_sheet(transformedData, { header: true });
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
      
          const fileName = 'exportedData.xlsx';
          XLSX.writeFile(workbook, fileName, { type: 'file' });
        } catch (error) {
          console.error('Error exporting Excel:', error);
        }
      };
      
    */



    const onFromDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            from_date: dateString
        });
    };

    const onFromDateLoad = () => {
        // console.log(date, dateString);
       // setSelectedFromDate(dateString)
        console.log('fromdate',form.getFieldValue('from_date_picker'));
    };

    const onEndDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            to_date: dateString
        });

    };



    const onFormSearched = async (values) => {
        const tapcoachParams = { 
            from_date : values.from_date,
            to_date : values.to_date,
           // tap_group: values.tap_group != undefined ? values.tap_group : ""
        };
// const url = `${TAP_COACH_REPORT_URL}${values.from_date}/${values.to_date}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`;

// console.log("url", url);
        window.open(`${TAP_COACH_REPORT_URL}${values.from_date}/${values.to_date}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`, '_blank', 'noreferrer');
    };


    return (

        <div>
            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Coach Report"
                        subTitle=""

                    ></PageHeader>

                    <Row className="" style={{ background: "#f4f4f4" }}>
                        <Col className="" xs={24} xl={24}>

                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFormSearched}
                                autoComplete="off"
                                initialValues={defaultFormValues}
                                
                            >

                                <Row gutter={20} style={{ margin: "0.5rem" }}>
                                    {/* <Col xs={4} xl={4} >
                                        <Form.Item name="tap_group" label="Morning/Special" >
                                            <Select className="text-left" allowClear={true} >
                                                <Option value="TAPM"> TAP Morning</Option>
                                                <Option value="TAPSP"> Special Coaching</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col> */}

                                        <Col xs={24} xl={3} >
                                            <Form.Item name="from_date_picker" label="From Date">
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_HYPHEN}
                                                    onChange={onFromDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    defaultValue={moment(commonUtility.firstDateOfMonth("-"), DATE_FORMAT_DMY_HYPHEN)}
                                                    placeholder=""
                                                />
                                            </Form.Item>
                                            <Form.Item name="from_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} >

                                            <Form.Item name="to_date_picker" label="To Date" >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_HYPHEN}
                                                    onChange={onEndDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    defaultValue={moment(commonUtility.lastDateOfMonth("-"), DATE_FORMAT_DMY_HYPHEN)}
                                                   
                                                    placeholder=""
                                                />
                                            </Form.Item>
                                            <Form.Item name="to_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                        </Col>

                                        {/* <Col xs={4} xl={5} >
                                            <Form.Item name="view_type" label="Invoice/Booking Chart">
                                                <Select className="text-left" allowClear={true} onChange={(value, event) => onViewTypeChange(value, event)} defaultValue="LIST"
                                                >
                                                    <Option value="LIST" >Invoice</Option>
                                                    <Option value="DAILY" >Booking Chart</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col> */}

                                        {/* <Col xs={4} xl={4} >
                                            <Form.Item name="tap_group" label="Type">
                                                <Select className="text-left">
                                                    <Option value="TAPM" valueText="Adult Coaching">Adult Coaching</Option>
                                                    <Option value="TAPSC" valueText="Special Coaching">Special Coaching</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col> */}

                                   



                                    <Col xs={4} xl={3} >
                                        <Form.Item label=" ">
                                            {
                                                reminderLoaderEnable ? <Spin /> : <>
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"
                                                        className="custom-button-green"
                                                    >
                                                        Excel <EyeOutlined />
                                                    </Button>
                                                </>
                                            }
{/* 
<Button
                                                        htmlType="button"
                                                        shape="round"
                                                        className="custom-button-green"
                                                        onClick={exportToExcel}
                                                    >
                                                        Excel <EyeOutlined />
                                                    </Button> */}

                                        </Form.Item>
                                    </Col>



                                </Row>
                            </Form>




                        </Col>
                    </Row>



                </div>
            </div>

        </div>







    )
}

export default TapCoachReport